import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import dayjs from 'dayjs';
import ReactSelect from '../ReactSelect';
import { cn } from '../../utils/misc';

const years = Array.from({ length: 10 }, (_, i) => (new Date().getFullYear() - i).toString());

export default function MonthTabs() {
    const thisYear = new Date().getFullYear().toString();
    const [year, setYear] = useState<string>(thisYear);

    const englishMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((m) => m.toLowerCase());
    const localeMonths = dayjs().localeData().months();

    useEffect(() => {
        const selector = document.querySelector('.sidebar ul a[href="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }, []);

    return (
        <div className="p-2.5">
            <ReactSelect
                defaultValue={{ value: thisYear, label: thisYear }}
                options={years.map((y) => ({ value: y, label: y }))}
                isSearchable={false}
                onChange={(option) => setYear(option?.value || new Date().getFullYear().toString())}
                className="w-full mb-2"
            />
            <div className="grid grid-cols-3 gap-2 mt-2">
                {englishMonths.map((m, index) => (
                    <NavLink
                        key={index + '-' + year}
                        to={`/dashboard/monthly-stats/${year}/${m.toLowerCase()}`}
                        className={cn(
                            'py-2 px-3 text-center rounded-md text-sm font-semibold',
                            'bg-white-light/30 dark:bg-dark/20 hover:bg-white-light/70 dark:hover:bg-dark/60',
                            window.location.pathname.includes(m.toLowerCase()) && window.location.pathname.includes(year) && 'dark:bg-dark/60 dark:hover:bg-dark'
                        )}
                    >
                        {localeMonths[index].substring(0, 3)}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}
